module.exports = __webpack_public_path__ + "static/a068c83e6f8f85b4d775ccf0447deaefa890472b5a1630b0f56bae232cf02d9b-b10e9550d336e6d3379c1bc26bbaaeab.jpeg";